<template>
    <div
        v-if="!noParticipants && registrationData.participatingPersons && registrationData.participatingPersons.length">
        <h2>
            <template v-if="changeWordingRegistrationBuy">
                {{ $t('eventRegistration.summary.persons') }}
            </template>
            <template v-else-if="isCaregiver">
                {{ $t('eventRegistration.summary.caregivers') }}
            </template>
            <template v-else>
                {{ $t('eventRegistration.summary.participants') }}
            </template>
        </h2>
        <ParticipantsListing :viewOnly="true">
        </ParticipantsListing>
    </div>
</template>

<script>
import ParticipantsListing from "@/components/pages/registration/ParticipantsListing";
import registrationOnlineRegistrationFieldsMixin from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";
import registrationCaregiverMixin from "@/mixins/registration/registrationCaregiverMixin";

export default {
    name: "Participants",
    mixins: [
        registrationOnlineRegistrationFieldsMixin,
        registrationCaregiverMixin
    ],
    components: {ParticipantsListing}

}
</script>

<style scoped>

</style>
